import { Link } from "react-router-dom";
import { categories } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="bg-primary-700 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-primary-600">
                <i className="ri-water-flash-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-display text-2xl font-black text-background-50">昨日吃瓜</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              一家只做「复盘」的娱乐热点编辑部。整理时间线、比对细节、归档疑点，让热闹变得有章可循。
            </p>
            <div className="mt-5 flex items-center gap-3 text-background-200">
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs">理性吃瓜</span>
              <span className="rounded-full bg-background-50/10 px-3 py-1 text-xs">以官方为准</span>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg font-bold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li><Link to="/" className="transition-colors hover:text-background-50">首页</Link></li>
              <li><Link to="/news" className="transition-colors hover:text-background-50">瓜田速递</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-background-50">关于我们</Link></li>
              <li><Link to="/#subscribe" className="transition-colors hover:text-background-50">订阅瓜报</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-bold text-background-50">栏目</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              {categories.map((c) => (
                <li key={c.id}>
                  <Link to={`/news?c=${c.id}`} className="transition-colors hover:text-background-50">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-bold text-background-50">联系编辑部</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" aria-hidden="true" />
                <span>hello@zuori-chigua.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line" aria-hidden="true" />
                <span>每天 10:00 - 22:00 在线</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line" aria-hidden="true" />
                <span>线上编辑部 · 全网可读</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-background-200">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-weibo-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-bilibili-line" aria-hidden="true" />
              </span>
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50/10 transition-colors hover:bg-background-50/20">
                <i className="ri-wechat-line" aria-hidden="true" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-200 sm:flex-row">
          <p>© 2026 昨日吃瓜 · 内容基于公开信息整理，观点与立场均不代表本站结论。</p>
          <p className="flex items-center gap-1">
            <i className="ri-empathize-line" aria-hidden="true" /> 有理有据地热闹
          </p>
        </div>
      </div>
    </footer>
  );
}